/* Fase 236 A (30/10-2026, Chef): kurvlinjer med egenskaben «Ekstra navn (gratis)» på juleuro-med-navn.
   - Antal > 1 (fx to ens tilføjelser, som Shopify slår sammen) sættes til 1 via /cart/change.js + kort besked.
   - Valnød/ikke birk 3/6 mm, eller dato efter 15/11-2026 (Europe/Copenhagen; ?ltdjul=YYYY-MM-DD simulerer):
     egenskaben fjernes via /cart/change.js med ALLE øvrige egenskaber uændret (læst fra /cart.js) + kort besked.
   Rører kun linjer for juleuro-med-navn. Ingen priser/rabatter/attributter ændres. Idempotent.
   Fase 236 B (30/10-2026, Chef): fjerner også «Ekstra navn – motiv» sammen med navnet. */
(function () {
  'use strict';
  if (window.__ltdEnCart) return; window.__ltdEnCart = true;
  var K = 'Ekstra navn (gratis)', KM = 'Ekstra navn – motiv', H = 'juleuro-med-navn', SS = 'ltdEnCartMsg';
  var M_QTY = 'Antal er sat til 1: det gratis ekstra navn gælder pr. uro. Læg hver uro i kurven for sig.';
  var M_DEL = 'Det gratis ekstra navn og dets motiv gælder kun birk 3 og 6 mm bestilt senest 15/11 kl. 23:59, så de er fjernet fra din kurv.';
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var of = window.fetch.bind(window), busy = false;
  function real() {
    try { return +new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).replace(/\D/g, ''); }
    catch (e) { var d = new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
  }
  /* Simulering kan kun flytte datoen frem (aldrig forlænge tilbuddet). */
  function today() { return Math.max(real(), sim()); }
  function sim() {
    var q = location.search.match(/[?&]ltdjul=(\d{4})-?(\d\d)-?(\d\d)/);
    if (q) { try { sessionStorage.setItem('ltdjul', q[1] + q[2] + q[3]); } catch (e) {} return +(q[1] + q[2] + q[3]); }
    try { var s = sessionStorage.getItem('ltdjul'); if (s && /[?&]utm_source=fase-test/.test(location.search)) return +s; } catch (e) {}
    return 0;
  }
  function show(txt) {
    var m = document.querySelector('[data-ltd-en-cart-msg]');
    if (!m) { m = document.createElement('p'); m.setAttribute('data-ltd-en-cart-msg', ''); m.setAttribute('role', 'status');
      m.style.cssText = 'position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:2147483000;max-width:min(560px,calc(100% - 32px));margin:0;padding:12px 16px;border-radius:8px;background:#24452f;color:#fff;font-size:14px;line-height:1.45;box-shadow:0 4px 16px rgba(0,0,0,.25)';
      document.body.appendChild(m); }
    m.textContent = txt; m.hidden = false; clearTimeout(show.t); show.t = setTimeout(function () { m.hidden = true; }, 10000);
  }
  function post(body) {
    return of(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); });
  }
  function check() {
    if (busy) return; busy = true;
    of(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) {
        var t = today(), job = null;
        (cart.items || []).some(function (it) {
          var p = it.properties || {};
          if (it.handle !== H || p[K] == null || String(p[K]).trim() === '') return false;
          var vt = it.variant_title || '', ok = /Birk (3|6) mm/.test(vt) && !/Valnød/i.test(vt) && t <= 20261115;
          if (!ok) { var np = {}; Object.keys(p).forEach(function (k) { if (k !== K && k !== KM) np[k] = p[k]; });
            job = { body: { id: it.key, quantity: it.quantity, properties: np }, msg: M_DEL }; return true; }
          if (it.quantity > 1) { job = { body: { id: it.key, quantity: 1 }, msg: M_QTY }; return true; }
          return false;
        });
        if (!job) { busy = false; try { sessionStorage.removeItem('ltdEnN'); } catch (e) {} var s = null; try { s = sessionStorage.getItem(SS); sessionStorage.removeItem(SS); } catch (e) {} if (s) show(s); return; }
        return post(job.body).then(function () {
          var n = 0; try { n = +(sessionStorage.getItem('ltdEnN') || 0) + 1; sessionStorage.setItem('ltdEnN', n); var pr = sessionStorage.getItem(SS) || ''; if (pr.indexOf(job.msg) === -1) sessionStorage.setItem(SS, pr ? pr + ' ' + job.msg : job.msg); } catch (e) {}
          if (n > 10) { busy = false; show(job.msg); return; }
          location.reload();
        });
      }).catch(function () { busy = false; });
  }
  /* Efter egne kurvopdateringer (tilføj/ændr) i Horizon-skuffen: tjek igen. */
  window.fetch = function (u, o) {
    var p = of(u, o); var s = typeof u === 'string' ? u : (u && u.url) || '';
    if (/\/cart\/(add|change|update)/.test(s)) p.then(function () { setTimeout(check, 300); }, function () {});
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
